import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import ScrollToTop from "./components/common/ScrollToTop";
import Loading from "./components/common/Loading";
import ErrorBoundary from "./components/error/ErrorBoundary";
import Layout from "./components/layout/Layout";
import { useAOS } from "./hooks/useAOS";
//import ContactUsFloating from "./components/layout/ContactUsFloating";

// Lazy pages
const HomePageLayout = lazy(() => import("./pages/HomePageLayout"));

const HomePage = lazy(() =>
  import("./pages/Trading and Installation/HomePage")
);
const ServicesPage = lazy(() =>
  import("./pages/Trading and Installation/ServicesPage")
);
const ProductsPage = lazy(() =>
  import("./pages/Trading and Installation/ProductsPage")
);
const ContactPage = lazy(() =>
  import("./pages/Trading and Installation/ContactPage")
);
const DemoPage = lazy(() =>
  import("./pages/Trading and Installation/DemoPage")
);

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Suspense fallback={<Loading />}>
        <Routes location={location} key={location.pathname}>
          
          {/* Gateway */}
          <Route path="/" element={<HomePageLayout />} />

          {/* Website A */}
          <Route path="/trading" element={<Layout />}>
            <Route index element={<DemoPage />} />
            <Route path="services" element={<ServicesPage />} />
            <Route path="products" element={<ProductsPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="demo" element={<DemoPage />} />
            <Route path="home" element={<HomePage />} />
          </Route>

        </Routes>
      </Suspense>
    </AnimatePresence>
  );
};

const App = () => {
  useAOS();

  return (
     <ErrorBoundary>
      <Router>
        <ScrollToTop />

        {/* Routes */}
        <AnimatedRoutes />

        {/* Floating Contact Us Button – always visible */}
        {/* <ContactUsFloating /> */}
      </Router>
    </ErrorBoundary>
  );
};

export default App;
